import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Mail, Phone, ArrowDown } from 'lucide-react';

const Hero = ({ data }) => {
  return (
    <section className="min-h-screen flex items-center justify-center relative overflow-hidden pt-16 section-spacing">
      {/* Background avec effet de grille style terminal */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(139,92,246,0.1),transparent_50%)]" />
      
      {/* Lignes de code animées en arrière-plan - CORRIGÉ: plus de 'Portfolio' non défini */}
      <div className="absolute inset-0 overflow-hidden opacity-20 font-mono text-xs text-gray-600">
        <div className="absolute top-20 left-[10%] animate-pulse  text-gray-400 opacity-80 text-base">function createApp() {'{'}</div>
        <div className="absolute top-40 right-[15%] animate-pulse  text-gray-400 opacity-40 text-base delay-1000">const Richard = new Developer();</div>
        <div className="absolute bottom-40 left-[20%] animate-pulse  text-gray-400 opacity-40 text-base delay-700">return &#60;App /&#62;</div> {/* Modifié ici */}
        <div className="absolute bottom-20 right-[25%] animate-pulse  text-gray-400 opacity-40 text-base delay-500">{'}'}</div>
      </div>

      <div className="relative z-10 text-center max-w-4xl mx-auto">
        <motion.div
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ duration: 0.8, type: "spring" }}
          className="mb-6"
        >
          <div className="text-sm font-mono text-violet-400 mb-2">~/whoami</div>
          <h1 className="text-5xl md:text-7xl font-bold mb-2">
            <span className="gradient-text">{data.name}</span>
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <div className="text-lg font-mono text-gray-500 mb-2">$ echo $TITLE</div>
          <h2 className="text-xl md:text-2xl text-gray-300 mb-2">
            {data.title}
          </h2>
          <p className="text-lg text-violet-400 font-mono mb-8">
            {data.subtitle}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="flex flex-col md:flex-row items-center justify-center gap-4 mb-12 font-mono text-sm"
        >
          <div className="flex items-center gap-2 text-gray-300 bg-dark-surface/50 px-4 py-2 rounded-full border border-dark-border">
            <MapPin size={16} className="text-violet-400" />
            <span>{data.location}</span>
          </div>
          <div className="flex items-center gap-2 text-gray-300 bg-dark-surface/50 px-4 py-2 rounded-full border border-dark-border">
            <Mail size={16} className="text-violet-400" />
            <a href={`mailto:${data.email}`} className="hover:text-violet-400 transition-colors">
              {data.email}
            </a>
          </div>
          <div className="flex items-center gap-2 text-gray-300 bg-dark-surface/50 px-4 py-2 rounded-full border border-dark-border">
            <Phone size={16} className="text-violet-400" />
            <a href={`tel:${data.phone}`} className="hover:text-violet-400 transition-colors">
              {data.phone}
            </a>
          </div>
        </motion.div>

        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="absolute bottom-10 left-1/2 transform -translate-x-1/2 cursor-pointer"
          onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
        >
          <div className="text-xs font-mono text-gray-500 mb-1">$ cd ./profil</div>
          <ArrowDown className="text-violet-400 mx-auto" size={24} />
        </motion.div>

        {/* Après les coordonnées, avant le bouton de scroll */}
        <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8 }}
        className="mt-8 flex items-center justify-center gap-2"
        >
        <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
        <span className="text-sm font-mono text-green-400">Ouvert aux opportunités</span>
        <span className="badge-success text-xs">Freelance • CDD • CDI</span>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;